module.exports = __webpack_public_path__ + "static/media/34-11.708f0f2c.mp3";